import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { useSetLocationData } from "~/hooks/locationData";
import DealerInfoPanel from "~/components/DealerInfoPanel";
import Folder from "~/components/Icons/icon-folder";
import Folder_2 from "~/components/Icons/icon-folder-2";
import { FOLDER_OPTIONS } from "./options";
import s from "./PKD.less";
import { usePermissions } from "~/shared/context/PermissionContext";
import { PkdLinks } from '~/widgets/PkdLinks';

interface Props {}

const PKD: FC<Props> = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const setData = useSetLocationData();
  const { hasPermission } = usePermissions();
  const openPkdFiles = (name: string, folderName: string) => {
    let departmentIds: string[] | undefined;
    if (name === "sales") {
      departmentIds = ["1"]; // Отдел продаж
    } else if (name === "after_sales") {
      departmentIds = ["2", "3"]; // Отдел сервиса
    } else if (name === "marketing") {
      departmentIds = ["7"]; // маркетинг
    } else if (name === "customer_service") {
      departmentIds = ["6"]; // Клиентский сервис
    } else if (name === "other") {
      departmentIds = ["4", "5", "8"]; // Отдел развития
    }

    if (
      departmentIds &&
      (folderName === "checklists" || folderName === "indicators")
    ) {
      history.push(`/${folderName}-department/${departmentIds}`);
    } else {
      let url = `/pkd/${name}/${folderName}`;
      history.push(url);
    }

    setData("event", `${name}_${folderName}`);
  };

  return (
    <div className={s.wrapper}>
      <PkdLinks />
      <div className={s.pkd_header}>
        <div className={s.pkd_title}>{t(`pkd.title`)}</div>
      </div>
      <DealerInfoPanel type="Staff" />

      <div className={s.wrapper_info}>
        {FOLDER_OPTIONS.map((folderName) => (
          <div className={s.item} key={folderName}>
            <div className={s.folder_wrapper}>
              <Folder width={"70"} height={"70"} fill={"#858E95"} />
              {t(`pkd.${folderName}`)}
            </div>
            <div
              onClick={() => openPkdFiles(folderName, "pkd")}
              className={s.folder_wrapper}
            >
              <Folder_2 />
              {t(`pkd.title`)}
            </div>
            <div
              onClick={() => openPkdFiles(folderName, "report")}
              className={s.folder_wrapper}
            >
              <Folder_2 />
              {t(`pkd.reports`)}
            </div>
            <div
              onClick={() => openPkdFiles(folderName, "dialog")}
              className={s.folder_wrapper}
            >
              <Folder_2 />
              {t(`pkd.dialog`)}
            </div>
            <>
              {hasPermission("pkd.getThree") && (
                <div
                  onClick={() => openPkdFiles(folderName, "indicators")}
                  className={s.folder_wrapper}
                >
                  <Folder_2 />
                  {t(`indicators.indicators`)}
                </div>
              )}
              {hasPermission("pkd.getCheckLists") && (
                <div
                  onClick={() => openPkdFiles(folderName, "checklists")}
                  className={s.folder_wrapper}
                >
                  <Folder_2 />
                  {t(`pkd.check_lists`)}
                </div>
              )}
            </>
          </div>
        ))}
      </div>
      <div className={'offset-footer'} />
    </div>
  );
};

export default PKD;
